(function () {
  'use strict';

  /**
   * WeTheme's wetheme-product-form (Vue 2) replaces/patches markup after mount (matches
   * subscription-plans-by-customer.js's own finding); any closed-over DOM refs from the first
   * paint can point at detached nodes. Every read below re-queries live instead of caching.
   */

  function getCaseDataByVariantId() {
    var el = document.querySelector('[data-case-pricing-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getVueProductFormRoot() {
    var wf = document.querySelector('wetheme-product-form');
    if (wf && wf.__vue__) return wf;
    var mount = document.querySelector('.product-form-vue');
    if (mount && mount.__vue__) return mount;
    return null;
  }

  function tryVm(v) {
    if (!v) return null;
    var variant = v.variant;
    if (!variant && v.$data) variant = v.$data.variant;
    if (typeof v._data !== 'undefined' && !variant) variant = v._data.variant;
    if (variant && typeof variant === 'object' && variant.id != null) return variant.id;
    return null;
  }

  /**
   * Same strategy as subscription-banner.js's getVariantIdFromWethemeVue: the root Vue
   * instance doesn't always carry `variant` (some swatch state lives on a child component),
   * so walk $children before giving up on the Vue read entirely.
   */
  function getVariantIdFromVm(rootVm, root) {
    if (!rootVm) return null;
    var fromRoot = tryVm(rootVm);
    if (fromRoot != null) return fromRoot;

    function walk(vm, depth) {
      if (!vm || depth > 12) return null;
      var ch = vm.$children;
      if (!ch || !ch.length) return null;
      for (var i = 0; i < ch.length; i++) {
        var c = ch[i];
        if (!c) continue;
        if (c.$el && c.$el.nodeType === 1 && root && !root.contains(c.$el)) continue;
        var got = tryVm(c);
        if (got != null) return got;
        got = walk(c, depth + 1);
        if (got != null) return got;
      }
      return null;
    }
    return walk(rootVm, 0);
  }

  function getParsedProductJson() {
    var el =
      document.querySelector('script.product-json[type="application/json"]') ||
      document.querySelector('script[type="application/json"].product-json') ||
      document.querySelector('[id^="ProductJson-"][type="application/json"]');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  /**
   * Same reasoning as subscription-banner.js's pickBestVariantIdInput: app blocks (reviews,
   * subscriptions, etc.) can inject their own spurious input[name="id"] into the form, so the
   * first match isn't trustworthy - validate against ProductJson's real variant ids first.
   */
  function pickBestVariantIdInput(form) {
    var list = form.querySelectorAll('input[name="id"]');
    if (!list.length) return null;
    var product = getParsedProductJson();
    var valid = {};
    var hasValid = false;
    if (product && product.variants) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v && v.id != null) {
          valid[String(v.id)] = true;
          hasValid = true;
        }
      }
    }
    for (var j = 0; j < list.length; j++) {
      var inp = list[j];
      if (!inp || !inp.value) continue;
      var s = String(inp.value).trim();
      if (!hasValid || valid[s]) return inp;
    }
    return hasValid ? null : list[0];
  }

  function getCurrentVariantId() {
    try {
      var el = getVueProductFormRoot();
      var vm = el && el.__vue__;
      var fromVue = getVariantIdFromVm(vm, el);
      if (fromVue != null) return String(fromVue);
    } catch (e) {
      // fall through to DOM-based lookup
    }
    var form = document.getElementById('AddToCartForm');
    if (!form) return null;
    var select = form.querySelector('.product-single__variants[name="id"], select[name="id"]');
    if (select && select.value) return String(select.value);
    var input = pickBestVariantIdInput(form);
    if (input && input.value) return String(input.value);
    return null;
  }

  function getMoneyFormat() {
    try {
      var wethemeGlobal = document.getElementById('wetheme-global');
      if (wethemeGlobal) {
        var data = JSON.parse(wethemeGlobal.textContent);
        if (data.moneyFormat) return data.moneyFormat;
      }
    } catch (e) {
      // use default below
    }
    return '${{amount}}';
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents) || cents < 0) cents = 0;
    var amount = (cents / 100).toFixed(2);
    var formatted = parseFloat(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    var moneyFormat = getMoneyFormat();
    if (moneyFormat.indexOf('{{amount}}') !== -1) return moneyFormat.replace('{{amount}}', formatted);
    if (moneyFormat.indexOf('{{amount_no_decimals}}') !== -1) {
      return moneyFormat.replace('{{amount_no_decimals}}', Math.round(cents / 100).toLocaleString('en-US'));
    }
    return '$' + formatted;
  }

  function getLiveRefs() {
    var container = document.querySelector('.case-pricing');
    if (!container) return null;
    return {
      container: container,
      segButtons: container.querySelectorAll('[data-case-mode]'),
      stepperEl: container.querySelector('.case-pricing__stepper'),
      countEl: container.querySelector('[data-case-count]'),
      summaryEl: container.querySelector('[data-case-summary]')
    };
  }

  var state = { mode: 'unit', count: 1 };
  var lastVariantId;

  function render() {
    var refs = getLiveRefs();
    if (!refs) return;

    var vid = getCurrentVariantId();
    if (vid !== lastVariantId) {
      // Switching size/variant shouldn't carry over a case count picked for a different case size.
      state.mode = 'unit';
      state.count = 1;
      lastVariantId = vid;
    }

    var caseDataByVariantId = getCaseDataByVariantId() || {};
    var data = vid != null ? caseDataByVariantId[vid] : null;

    if (!data) {
      refs.container.hidden = true;
      return;
    }

    refs.container.hidden = false;
    refs.segButtons.forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-case-mode') === state.mode);
    });
    if (refs.stepperEl) refs.stepperEl.hidden = state.mode !== 'case';
    if (refs.countEl) refs.countEl.textContent = state.count;

    if (state.mode === 'case') {
      var units = state.count * data.caseSize;
      var total = units * data.casePriceCents;
      var listTotal = units * data.eachPriceCents;
      var savings = listTotal - total;
      var summary = state.count + (state.count === 1 ? ' case' : ' cases') + ' · ' + units + ' units · ' + formatMoney(total);
      if (savings > 0) summary += ' (save ' + formatMoney(savings) + ')';
      if (refs.summaryEl) refs.summaryEl.textContent = summary;
    } else if (refs.summaryEl) {
      refs.summaryEl.textContent = '';
    }
  }

  /**
   * Vue's variant state can lag a tick behind whichever DOM event told us to resync (matches
   * subscription-plans-by-customer.js's queueShowVariantPlans) - run now and on later frames/timeouts
   * rather than trusting a single event to land after Vue has actually updated.
   */
  var queuedRafIds = [];
  var queuedTimerIds = [];
  function queueRender() {
    queuedRafIds.splice(0).forEach(function (id) {
      try { cancelAnimationFrame(id); } catch (e) {}
    });
    queuedTimerIds.splice(0).forEach(clearTimeout);
    render();
    try {
      queuedRafIds.push(requestAnimationFrame(function () {
        render();
        queuedRafIds.push(requestAnimationFrame(render));
      }));
    } catch (e) {}
    [0, 35, 100, 220].forEach(function (ms) {
      queuedTimerIds.push(setTimeout(render, ms));
    });
  }

  if (!window.__clnfCasePricingDocBound) {
    window.__clnfCasePricingDocBound = true;

    /** Delegated so it keeps working after Vue replaces the container's nodes. */
    document.addEventListener(
      'click',
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;

        var seg = t.closest('[data-case-mode]');
        if (seg && seg.closest('.case-pricing')) {
          var mode = seg.getAttribute('data-case-mode');
          if (mode !== state.mode) {
            state.mode = mode;
            state.count = 1;
            render();
          }
          return;
        }

        var step = t.closest('[data-case-step]');
        if (step && step.closest('.case-pricing')) {
          var delta = parseInt(step.getAttribute('data-case-step'), 10);
          state.count = Math.max(1, state.count + delta);
          render();
          return;
        }

        if (t.closest('.swatch-element')) {
          queueRender();
        }
      },
      true
    );

    document.addEventListener(
      'change',
      function (ev) {
        var form = document.getElementById('AddToCartForm');
        if (!form || !ev.target || !form.contains(ev.target)) return;
        queueRender();
      },
      false
    );

    document.addEventListener('variant:change', function (ev) {
      if (ev.detail && ev.detail.variant) queueRender();
    });

    /**
     * onAddToCart fires from a Vue-internal reactive watcher chain triggered synchronously by the
     * button's own click handler, not from a native form "submit" listener race we can win from
     * outside - by the time any "submit" event exists, onAddToCart has already read the (stale)
     * quantity and already sent the cart request. Same conclusion the subscription UI reached
     * (see subscription-plans-by-customer.js's dedicated subscribe button): the only reliable fix
     * is to fully take over the click for case mode and add to cart ourselves, exactly like that
     * button does. Non-case clicks are left completely alone so normal purchases are unaffected.
     */
    function clnfCaseCartAddUrl() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root + 'cart/add.js';
    }

    function clnfOpenCartDrawerAfterCaseAdd() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (window.wetheme && typeof window.wetheme.toggleRightDrawer === 'function') {
            window.wetheme.toggleRightDrawer('cart', true, { cart: cart });
          }
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
        });
    }

    document.addEventListener(
      'click',
      function (ev) {
        if (state.mode !== 'case') return;
        var btn = ev.target && ev.target.closest && ev.target.closest('.js-product-atc-btn, #AddToCart--main, button[name="add"]');
        if (!btn) return;
        var form = document.getElementById('AddToCartForm');
        if (!form || !form.contains(btn)) return;

        var vid = getCurrentVariantId();
        var caseDataByVariantId = getCaseDataByVariantId() || {};
        var data = vid != null ? caseDataByVariantId[vid] : null;
        if (!data) return; // no resolvable case data - fall back to the normal add-to-cart flow

        ev.preventDefault();
        ev.stopImmediatePropagation();

        if (btn.disabled) return;
        var totalUnits = state.count * data.caseSize;
        btn.disabled = true;

        fetch(clnfCaseCartAddUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          /**
           * subscription-plans-by-customer.js globally wraps window.fetch/XHR to inject a
           * selling_plan into any cart/add request whose item has no selling_plan key at all
           * (it has to — Vue's own internal add-to-cart XHR never exposes selling_plan). A case
           * purchase is always one-time regardless of whatever subscription radio is currently
           * checked elsewhere on the page, so explicitly declaring selling_plan: null here opts
           * this request out of that injection instead of silently inheriting a stale plan id.
           */
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: totalUnits, selling_plan: null }] })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function (data) {
            btn.disabled = false;
            var line = data && data.items && data.items[0] ? data.items[0] : data;
            var lineVariant = line && (line.variant_id || line.id);
            if (window.trackAddToCart && lineVariant) {
              try {
                window.trackAddToCart(lineVariant, line.quantity || totalUnits, {
                  product_id: line.product_id,
                  product_title: line.product_title || line.title,
                  variant_title: line.variant_title,
                  price: (line.price || 0) / 100,
                  value: ((line.price || 0) * (line.quantity || totalUnits)) / 100,
                  currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
                });
              } catch (eT) {}
            }
            clnfOpenCartDrawerAfterCaseAdd();
          })
          .catch(function (err) {
            btn.disabled = false;
            var msg = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
            window.alert(msg);
          });
      },
      true
    );

    document.addEventListener('shopify:section:load', function () {
      setTimeout(queueRender, 80);
      setTimeout(queueRender, 400);
    });
  }

  [0, 50, 120, 300, 700, 1600].forEach(function (ms) {
    setTimeout(render, ms);
  });
})();
